<ng-template #triggerOverlay="rtConnectedOverlay" rt-connected-overlay>
  <div
    #overlayTriggerOrigin="rtOverlayOrigin"
    rt-overlay-origin
    (keydown)="onKeyDown($event)"
    [attr.tabindex]="0"
    class="focusable"
    layout-full-width
  >
    <ng-template
      [ngTemplateOutlet]="selectController.triggerDirective.templateRef"
      [ngTemplateOutletContext]="{ $implicit: selectController, inOverlay: true }"
    ></ng-template>
  </div>
</ng-template>

<div
  #inlineTriggerOrigin="rtOverlayOrigin"
  rt-overlay-origin
  (keydown)="onKeyDown($event)"
  [attr.tabindex]="0"
  class="focusable"
>
  <ng-template
    [ngTemplateOutlet]="selectController.triggerDirective.templateRef"
    [ngTemplateOutletContext]="{ $implicit: selectController, inOverlay: false }"
  ></ng-template>
</div>

<ng-template #dropdownTemplate #dropdownConnectedOverlay="rtConnectedOverlay" rt-connected-overlay>
  <rt-dropdown
    [width]="DropdownWidth.FullWidth"
    (keydown)="onKeyDown($event)"
    [attr.tabindex]="0"
    class="focusable"
  >
    @for (item of selectController.headerTemplates; track trackByTemplate($index, item)) {
      <ng-container [ngTemplateOutlet]="item.template"></ng-container>
    }
    @if (itemsLoading) {
      <rt-spinner />
    } @else {
      <virtual-scroller
        #virtual
        [bufferAmount]="20"
        [scrollAnimationTime]="0"
        [scrollThrottlingTime]="10"
        [enableUnequalChildrenSizes]="true"
        [executeRefreshOutsideAngularZone]="true"
        [compareItems]="vsCompareItems || vsCompareItemsFallback"
        [items]="(selectController.itemsToRender$ | ngrxPush) ?? []"
        (vsChange)="onVirtualScrollUpdate($event)"
        (vsEnd)="onVsEnd($event)"
        [ngStyle]="virtualScrollStyle"
      >
        @for (
          item of virtual.viewPortItems;
          track trackByValue(index, item);
          let index = $index;
          let isLast = $last
        ) {
          <rt-select-item-wrapper
            [templateOutlet]="selectController.listItemDirective.templateRef"
            [templateOutletContext]="{
              $implicit: selectController,
              index: index + virtualScrollIndexOffset,
              isHoverState: selectController.isHovered(index + virtualScrollIndexOffset),
              item,
              isLast
            }"
          />
        }
      </virtual-scroller>
    }
    @for (item of selectController.footerTemplates; track trackByTemplate($index, item)) {
      <ng-container [ngTemplateOutlet]="item.template"></ng-container>
    }
  </rt-dropdown>
</ng-template>
